import androidIcon from "../svgs/android.svg";
import caminhaodIcon from "../svgs/caminhao.svg";
import disneydIcon from "../svgs/disney.svg";
import estrelaIcon from "../svgs/estrela.svg";
import gasolinadIcon from "../svgs/gasolina.svg";
import motoIcon from "../svgs/moto.svg";

export const items = [
  { name: "android", icon: androidIcon },
  { name: "caminhao", icon: caminhaodIcon },
  { name: "disney", icon: disneydIcon },
  { name: "estrela", icon: estrelaIcon },
  { name: "gasolina", icon: gasolinadIcon },
  { name: "moto", icon: motoIcon },
];
